module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-3.c1b437ff.png";